module.exports = __webpack_public_path__ + "assets/img/loading-petals-spritesheet.03962bca.png";